module.exports = __webpack_public_path__ + "static/img/yaocai.cfbc50de.png";